module.exports = __webpack_public_path__ + "img/shredder.b440c56f.svg";